export default __webpack_public_path__ + "static/media/RosinaLovelace.3b67a808.png";